<template>
  <footer class="footer" :class="{ visible: isVisible }">
    <div class="footer-content" aria-label="Seitenfuß Navigation">
      <span class="copyright">&copy; {{ currentYear }} Amite Clothing</span>
      <span class="separator" aria-hidden="true">·</span>
      <router-link to="/impressum" class="legal-link">Impressum</router-link>
      <span class="separator" aria-hidden="true">·</span>
      <router-link to="/datenschutz" class="legal-link">Datenschutz</router-link>
      <span class="separator" aria-hidden="true">·</span>
      <router-link to="/agb" class="legal-link">AGB</router-link>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isVisible: false,
      currentYear: new Date().getFullYear()
    }
  },
  mounted() {
    setTimeout(() => {
      this.isVisible = true;
    }, 900);
  }
}
</script>

<style scoped>
.footer-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  line-height: 1.2;
  opacity: 0.9;
}

.legal-link {
  color: inherit;
  text-decoration: none;
  font-size: 0.85rem;
}

.legal-link:hover { text-decoration: underline; }

.separator { color: #666; }

@media (max-width: 480px) {
  .footer-content {
    gap: 0.4rem;
    font-size: 0.8rem;
  }
}
</style>